import { observer } from 'mobx-react-lite';
import {
  Icon,
  Container,
  Header,
  Segment,
  Image,
  Grid,
  Button,
  Divider,
} from 'semantic-ui-react';
import { useStore } from '../../app/stores/store';
import LoginForm from '../Users/LoginForm';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import { userLanguage } from '../../app/common/userLanguageSchema/userLanguage';
import '../../app/common/MediaQuery/mediaQuery.css';
import { useEffect } from 'react';
import agent from '../../app/api/agent';

export default observer(function HomePage() {
  const history = useNavigate();

  const { userStore, commonStore } = useStore();
  const { loginOutLoginpage } = userStore;
  useEffect(() => {
    loginOutLoginpage();
    // eslint-disable-next-line
  }, []);
  const restoraionRouteHandler = async (name:string)=>{
    let assetResult = await agent.AssetTypes.smartflowTemplate();
    const filterCriterion = name === 'Restoration' ? 'Production Process' : 'Cutlist';
    const filterRounte = assetResult.data.filter((item: any) => item.name.includes(filterCriterion)); 
    let ids = filterRounte[0]?.id?.split('_');
    let routeId = `/smart_flow/asset/${ids[0]}/element/${ids[1]}/template/${ids[2]}`;
    history(routeId)
    // setSmartTrackerRoute(routeId);
  }
  if([
    'Resto Admin',
    'Basic User',
    'Operator',
    'Process Lead',
    'Process Specialist',
    'Production Co-ordinator',
    'Quality Check',
    'Restoration Admin',
    'ProcessLead',
    'QC',
    'Client QC',
    'Colorization',
  ].includes(userStore.user?.roleName as string) &&
  userStore.user?.customerName === 'Restoration'){
    restoraionRouteHandler('Restoration');
}
if(['Quality Check','Operator'].includes(userStore.user?.roleName as string) &&
userStore.user?.customerName === 'NFAIReport'){
  restoraionRouteHandler('NFAIReport');
}
  if([
    'Resto Admin',
    'Basic User',
    'Operator',
    'Process Lead',
    'Process Specialist',
    'Production Co-ordinator',
    'Quality Check',
    'Restoration Admin',
    'ProcessLead',
    'QC',
    'Client QC',
    'Colorization',
  ].includes(userStore.user?.roleName as string) &&
  userStore.user?.customerName === 'Restoration'){
    restoraionRouteHandler('Restoration');
}
  const customerBasedRoute = () => {
   if (
      ['LVP CMS - SOB', 'Mumbai', 'Area 51'].includes(
        userStore?.user?.customerName as string,
      )
    ) {
      return '/dynamic_dashboard';
    } else if (
      userStore.user?.customerName === 'Museum' ||
      userStore.user?.customerName === 'Isha Foundation'
    ) {
      return '/mediaAssets';
    } else if (userStore.user?.customerName === 'LVP CMS - AM') {
      return '/dynamic_dashboard';
    }
    else if(userStore?.user?.customerName === 'PCPLCRM' && userStore?.user?.roleName?.trim() !== 'IT Team'){
     return '/CRM_SmartFlow'
    } else {
      return '/dashboard';
    }
  };
  if (userStore.isLoggedIn) {
    return <Navigate to={customerBasedRoute()} />;
  }

  return (
    <div className="login-sm">
      <Grid stackable relaxed>
        <Grid.Column width="10">
          <Segment inverted textAlign="center" vertical className="masthead">
            <Container text>
              <div className="lap">
                <Image
                  size="large"
                  src={`/assets/${(userLanguage[0].Login?.LI1 as any)?.[
                    `${commonStore.language.key}`
                  ]}.png`}
                  alt="logo"
                />
              </div>
              <Header
                as="h2"
                inverted
                content={
                  (userLanguage[0].Login?.LL1 as any)?.[
                    `${commonStore.language.key}`
                  ]
                }
              />
              <p>
                {
                  (userLanguage[0].Login?.LL2 as any)?.[
                    `${commonStore.language.key}`
                  ]
                }
              </p>
              <p>
                {
                  (userLanguage[0].Login?.LL3 as any)?.[
                    `${commonStore.language.key}`
                  ]
                }
              </p>
            </Container>
          </Segment>
        </Grid.Column>
        <Grid.Column width="6" verticalAlign="middle" className="signupform">
          <div className="header-image">
            <Image
              size="large"
              src={`/assets/${(userLanguage[0].Login?.LI1 as any)?.[
                `${commonStore.language.key}`
              ]}.png`}
              alt="logo"
            />
          </div>
          <div className="signupsegment">
            <Segment
              piled
              placeholder
              verticalAlign="middle"
              style={{
                border: 'none',
                background: 'white',
                alignItems: 'center',
              }}
            >
              <h3>
                <Icon name="sign in" />
                {
                  (userLanguage[0].Login?.LL4 as any)?.[
                    `${commonStore.language.key}`
                  ]
                }
              </h3>
              <LoginForm />
              <Divider horizontal>Or</Divider>
              <br />
              <Button
                fluid
                as={Link}
                to="/instantPage"
                // disabled={true}
                // onClick={() => dashboardStore.openSignUpUserModal(true)}
                // onClick={()=>routeChange('/instantPage')}
                primary
                icon="google"
              >
                {' '}
                {
                  (userLanguage[0].Login?.LB2 as any)?.[
                    `${commonStore.language.key}`
                  ]
                }
              </Button>
              <br />
            </Segment>
          </div>
        </Grid.Column>
      </Grid>
    </div>
  );
});
